import api from '../services/api';

export default async function () {
	let { data } = await api.fetchCadastro();
	return data.cadastroModoAdmin;
}